import { Person } from "@mui/icons-material"
import {
  Avatar,
  Divider,
  IconButton,
  MenuList,
  Popover,
  Stack
} from "@mui/material"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"

import { useLeftNavigationContext } from "@contexts/left_navigation_context"
import ItemContainer from "@layouts/main_layout/sub_components/navigation_panel/sub_components/item_container"
import LogoutDialogRow from "@layouts/main_layout/sub_components/navigation_panel/sub_components/profile/sub_components/logout_dialog_row"
import NavigationRow from "@layouts/main_layout/sub_components/navigation_panel/sub_components/profile/sub_components/navigation_row"

import styles from "./styles"

export default function NavigationPanelProfile() {
  const [popoverButtonElement, setPopoverButtonElement] =
    useState<HTMLButtonElement | null>(null)

  const { translate } = useLeftNavigationContext()
  const navigate = useNavigate()

  function navigateToPage(pathname: string) {
    navigate(`/account/${pathname}`)
  }

  function handleClickPopoverButton(
    event: React.MouseEvent<HTMLButtonElement>
  ) {
    setPopoverButtonElement(event.currentTarget)
  }

  function handleClosePopover() {
    setPopoverButtonElement(null)
  }

  return (
    <>
      <ItemContainer>
        <IconButton onClick={handleClickPopoverButton}>
          <Avatar src={""} sx={styles.avatar} />
        </IconButton>
      </ItemContainer>
      <Popover
        open={!!popoverButtonElement}
        anchorEl={popoverButtonElement}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <MenuList>
          <Stack sx={{ minWidth: "15rem" }}>
            <Stack rowGap={1}>
              <NavigationRow
                text={translate("profile")}
                Icon={Person}
                onClick={() => navigateToPage("profile")}
              />
            </Stack>
            <Divider />
            <Stack rowGap={1}>
              <LogoutDialogRow />
            </Stack>
          </Stack>
        </MenuList>
      </Popover>
    </>
  )
}
